export default __webpack_public_path__ + "static/media/new-divers-icon.714f7241.jpg";